<template>
    <div class="bg-color pb-5">
        <Header></Header>

        <Menu v-show="showMainMenu"></Menu>

        <router-view></router-view>

        <Footer v-if="loggedIn"></Footer>

        <div class="border-t border-white ml-4 mr-4 mt-4">
            <div class="mt-4 flex justify-between">
                <div class="w-1/3">
                    <div class="underline">{{ $t('component.footer.menu.mainMenu')}}</div>

                    <div class="mt-2">
                        <a class="block" href="#" @click="$router.push({ name: 'app' }).catch(()=>{})">{{
                            $t('component.menu.start') }}</a>
                        <a class="block" href="#" @click="$router.push({ name: 'applications' }).catch(()=>{})">{{
                            $t('component.menu.applications') }}</a>
                        <a class="block" href="#" @click="$router.push({ name: 'favorites' }).catch(()=>{})">{{
                            $t('component.menu.favorites') }}</a>
                        <a class="block" href="#" @click="$router.push({ name: 'excluded' }).catch(()=>{})">{{
                            $t('component.menu.excluded') }}</a>
                        <a class="block" href="#" @click="$router.push({ name: 'profile' }).catch(()=>{})">{{
                            $t('component.menu.profile') }}</a>
                        <a class="block" href="#" @click="$router.push({ name: 'info' }).catch(()=>{})">{{
                            $t('component.menu.info') }}</a>
                        <a class="block" href="#" @click="$router.push({ name: 'corona'}).catch(()=>{})">{{
                            $t('component.menu.corona') }}</a>
                        <a class="block" href="#" v-if="loggedIn" @click="$store.dispatch('auth/logout').catch(()=>{})">{{
                            $t('component.menu.logout') }}</a>
                        <a class="block" href="#" v-else
                           @click="$router.push({ name: 'signin', params: {signInModal: true}}).catch(()=>{})">{{
                            $t('component.menu.signin') }}</a>
                    </div>
                </div>
                <div class="w-1/3">
                    <div class="mt-1">
                        <img :src="getLogoUrl">
                    </div>
                    <div class="mt-2 uppercase text-gray-600 text-sm m-auto mb-5">
                        <div>{{getDlGroupName}}</div>
                        <div>{{getAddress.street}}</div>
                        <div>{{getAddress.zip + " " + getAddress.city}}</div>
                    </div>
                    <div class="flex">
                        <div @click="changeLanguage('pl')">
                            <PolandFlagSVG class="w-6 cursor-pointer"></PolandFlagSVG>
                        </div>
                        <div class="ml-2" @click="changeLanguage('de')">
                            <GermanyFlagSVG class="w-6 cursor-pointer"></GermanyFlagSVG>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <CookieAlert></CookieAlert>

        <portal-target name="modals">
        </portal-target>

        <portal to="modals">
            <SignIn :prevent-redirect-on-close="true" v-if="showSignInModal"
                    @close="$store.commit('app/hideSignInModal')">
            </SignIn>
            <GdprModal v-if="showGdprModal"
                       @close="closing">
            </GdprModal>

            <AgreementModal/>
            <UpdateAvailabilityModal/>
        </portal>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {PortalTarget, Portal} from 'portal-vue';

    import Header from "@/components/Header";
    import Footer from "@/components/cards/FooterCard";
    import Menu from "@/components/Menu";
    import SignIn from "@/components/modals/SignInModal";
    import PolandFlagSVG from "@/components/shared/svgs/PolandFlagSVG";
    import GermanyFlagSVG from "@/components/shared/svgs/GermanyFlagSVG";
    import CookieAlert from "../components/CookieAlert";
    import GdprModal from "../components/modals/GdprModal";
    import UserService from "../services/user.service";
    import AgreementModal from "../components/modals/AgreementModal";
    import UpdateAvailabilityModal from "../components/modals/UpdateAvailabilityModal";
    import {EventBus} from "../event-bus";

    export default {
        name: "AppLayout",
        components: {
            UpdateAvailabilityModal,
            AgreementModal,
            GdprModal,
            CookieAlert,
            GermanyFlagSVG, PolandFlagSVG,
            SignIn,
            Menu, Footer, Header, PortalTarget, Portal
        },
        computed: {
            ...mapGetters('app', {
                showMainMenu: 'showMainMenu',
                showConfirmIdentityModal: 'showConfirmIdentityModal',
                showSignInModal: 'showSignInModal',
                showGdprModal: 'showGdprModal'
            }),

            ...mapGetters('auth', {
                'loggedIn': 'loggedIn',
                user: 'user'
            }),

            ...mapGetters('dlGroupConfig', [
                'getDlGroupName',
                'getLogoUrl',
                'getAddress',
            ])
        },
        methods: {
            closing() {
                this.$store.commit('app/hideGdprModal')
            },

            changeLanguage(language) {
                this.$i18n.locale = language;
                if (this.loggedIn) {
                    UserService.setLanguage(language).then(async () => {
                        EventBus.$emit('onChangeLocale', language);
                        this.$store.dispatch('auth/filter');
                    });
                } else {
                    this.$store.dispatch('auth/anonymisedFilter');
                    EventBus.$emit('onChangeLocale');
                }
                this.updateInfoPage();
                const html = document.documentElement; // returns the html tag
                html.setAttribute('lang', this.$i18n.locale);
            },

            updateInfoPage() {
                this.$store.dispatch('dlGroupConfig/getInfoPage', this.$i18n.locale);
            }
        }
    }
</script>

<style scoped>
    .bg-color {
        background-color: #e3e4e6;
    }
</style>>